import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import VehicleHireForm, { VehicleHireFormModeEnum } from '../VehicleHireForm';
const VehicleHireCreatePage = () => {
    return (_jsx(VehicleHireForm, { mode: VehicleHireFormModeEnum.MODE_CREATE }));
};
export default VehicleHireCreatePage;
